<template>
  <v-app id="sandbox">
    <core-toolbar color="primary">
      <template slot="toolbar-avatar">
        <v-avatar style="cursor: pointer" size="85" class="ml-3" tile>
          <v-img src="~/shared/images/svg/logo-inverted.svg" width="100%" contain/>
        </v-avatar>
      </template>
      <template slot="toolbar-title">
        <v-toolbar-title style="cursor: pointer" class="pl-3 pr-2 secondary--text">BMP Config</v-toolbar-title>
      </template>
      <template slot="toolbar-drawer">
        <v-app-bar-nav-icon @click.stop="$store.commit('drawer')" color="secondary"/>
      </template>
    </core-toolbar>

    <core-menu></core-menu>

    <v-main>
      <v-container fluid>
        <v-breadcrumbs v-if="showBreadcrumbs" :items="breadcrumbs" class="ml-1 pl-2 pb-0 pt-4 pl-0">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
              <v-icon v-if="item.icon" :color="item.disabled? 'secondary lighten-2' : 'secondary'" small :x-small="$vuetify.breakpoint[$theme.options.compact.breadcrumbs]" left>{{item.icon}}</v-icon>&nbsp;
              <div :class="(item.disabled? 'secondary--text text--lighten-2' : 'secondary--text') + ' ' + ($vuetify.breakpoint[$theme.options.compact.breadcrumbs] ? 'text-body-2' : 'text-h6')" class=" font-weight-bold">{{ item.text }}</div>
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon small>mdi mdi-chevron-double-right</v-icon>
          </template>
        </v-breadcrumbs>

        <v-row>
          <v-col cols="12">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <slot name="footer">
      <v-footer inset app>
        <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>
    </slot>
  </v-app>
</template>

<script>
export default {
  props: {
    showMenu: { type: Boolean, default: true },
    showBreadcrumbs: { type: Boolean, default: true }
  },
  data () {
    return {

    }
  },
  computed: {
    breadcrumbs: function () {
      var route = this.$route
      if (route.meta.breadcrumbs) {
        return route.meta.breadcrumbs.map(function (p, i) {
          if (i === route.meta.breadcrumbs.length - 1) { p.disabled = true }

          return p
        })
      } else return []
    }
  }
}
</script>
